import { array, struct } from 'io-ts/Decoder';

import { Id as ClientId } from '../../../client/Id';

export const Request = struct({
	clientIds: array(ClientId),
});
